import React from 'react';
import { motion } from 'framer-motion';
import './GalleryAndTestimonials.css';

const GalleryAndTestimonials = () => {
  const galleryItems = [
    { image: 'https://www.mitsubishi-forklift.co.uk/hubfs/A_UK/Power%20Pallet%20Trucks/PREMIAESSBPN3-MINAPP-HIWEB-19-L.jpg', caption: 'Pallet Power' },
    { image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRdLk7k9eTUHDZI0-3L5LU-8KWLs8At4IrYUA&s', caption: 'Snack Stacks' },
    { image: 'https://hips.hearstapps.com/hmg-prod/images/screenshot-2024-08-15-at-3-08-00-pm-66be52fb7c32a.png?crop=1xw:1xh;center,top&resize=980:*', caption: 'Drinks Drop' },
    { image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4GFpl97ZOJG5-RpAsxVN1re71PYFcwMsMyQ&s', caption: 'Rollin’ Bulk' },
    { image: 'https://images.unsplash.com/photo-1595854341625-f33ee10dbf94?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80', caption: 'Frozen Frenzy' },
  ];

  const testimonials = [
    { quote: 'KVP’s bulk drinks keep my shop buzzing—cheap, fast, and the punters love it!', author: 'Mick Jones', role: 'Shopkeeper, Leeds' },
    { quote: 'Snacks and cleaning gear in one haul—KVP’s prices mean I’m laughing to the bank.', author: 'Sara Ahmed', role: 'Market Trader, Bristol' },
    { quote: 'Pallet deals on frozen stuff? Sorted my cafe’s stock for weeks—top notch!', author: 'Tony Briggs', role: 'Cafe Owner, Glasgow' },
    { quote: 'Bulk toilet rolls and soaps—KVP’s got my stalls sorted with killer value.', author: 'Priya Singh', role: 'Vendor, London' },
  ];

  return (
    <section className="gallery-testimonial-section">
      <div className="gallery-testimonial-container">
        {/* Gallery Section */}
        <div className="gallery">
          <motion.h2
            className="gallery-title"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Warehouse Snapshots
          </motion.h2>
          <div className="gallery-stack">
            {galleryItems.map((item, index) => (
              <motion.div
                key={index}
                className="gallery-polaroid"
                initial={{ opacity: 0, rotate: index % 2 === 0 ? -5 : 5, y: 50 }}
                whileInView={{ opacity: 1, rotate: 0, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.1, zIndex: 10 }}
                viewport={{ once: true }}
              >
                <img src={item.image} alt={item.caption} />
                <span className="gallery-label">{item.caption}</span>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Testimonial Section */}
        <div className="testimonials">
          <motion.h2
            className="testimonial-title"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            Trader Shoutouts
          </motion.h2>
          <div className="testimonial-stack">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                className="testimonial-card"
                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ scale: 1.05, zIndex: 5 }}
                viewport={{ once: true }}
              >
                <p className="testimonial-text">{testimonial.quote}</p>
                <p className="testimonial-name">{testimonial.author}</p>
                <p className="testimonial-job">{testimonial.role}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GalleryAndTestimonials;